const mutations = {
  LOAD_LIST_EVENT_TASKS(state, list) {
    state.listaEventTasks = list;
  },
  PREPARE_TO_EDIT_EVENT_TASK(state, data) {
    state.eventTask = { ...data };
  },
  RESET_EVENT_TASK(state) {
    state.eventTask = {
      id: null,
      evento: { id: null },
      titulo: "",
      descricao: "",
      responsavel: { id: null },
      dataPrevista: null,
      concluida: false,
      dataConclusao: null,
      ativo: true,
    };
  },
};

export default mutations;
